module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/home/for-you-20a0e504a3d1b63f8f34599322c1d5f2.svg";